import classNames from 'classnames';
import type { Dispatch } from 'react';

import { Input, Text } from '@revelio/ui';

import type { TabContentAction } from '../PageConfigProvider/page-reducer';
import type { PositionedItem } from '../PageConfigProvider/types/item';
import panelStyles from './ChartBuilderPanel.module.css';
import { ConfigSection } from './ConfigSection';
import styles from './sankey-label-settings.module.css';
import labelStyles from './section-label.module.css';

const fieldClassName = classNames(panelStyles.field, panelStyles.compactField);

type SankeyLabelSettingsProps = {
  item: PositionedItem;
  dispatch: Dispatch<TabContentAction>;
};

export const SankeyLabelSettings = ({
  item,
  dispatch,
}: SankeyLabelSettingsProps) => {
  const id = item?.id;
  const sankey = item?.plot?.sankey;

  return (
    <ConfigSection title="Flow labels">
      <div className={styles.fieldStack}>
        <div>
          <Text
            fontSize="sm"
            weight="semibold"
            className={labelStyles.fieldLabel}
          >
            Left Label
          </Text>
          <Input
            size="sm"
            wrapperClassName={fieldClassName}
            placeholder="Inflow"
            value={sankey?.leftFlowLabel ?? ''}
            onChange={(e) => {
              dispatch({
                type: 'UPDATE_ITEM_SANKEY_OPTIONS',
                payload: { id, leftFlowLabel: e.target.value },
              });
            }}
          />
        </div>
        <div>
          <Text
            fontSize="sm"
            weight="semibold"
            className={labelStyles.fieldLabel}
          >
            Right Label
          </Text>
          <Input
            size="sm"
            wrapperClassName={fieldClassName}
            placeholder="Outflow"
            value={sankey?.rightFlowLabel ?? ''}
            onChange={(e) => {
              dispatch({
                type: 'UPDATE_ITEM_SANKEY_OPTIONS',
                payload: { id, rightFlowLabel: e.target.value },
              });
            }}
          />
        </div>
      </div>
    </ConfigSection>
  );
};
